import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const pains = ['Ves a todos hablando de AI, pero nadie te dice cómo cobrar con ella.', 'Compraste cursos sueltos y terminaste con teoría, no con clientes.', 'No sabes qué vender, a quién, ni con qué precio empezar.', 'Te frena la parte técnica: sitio web, CRM, anuncios, seguimiento.'];
const shifts = ['Una oferta concreta que negocios locales ya están pagando.', 'Un plan de 48 horas con pasos medibles, no con módulos infinitos.', 'Target, precio y script definidos antes de tu primera conversación.', 'Sitio web, CRM y automatización ya armados y listos para publicar.'];
export function PainPoints() {
  return <section className="w-full bg-ink-900 py-20" aria-labelledby="problema" data-id="element-112" data-mp="3idungip6pxg6">
      <div className="mx-auto max-w-5xl px-5" data-id="element-113" data-mp="3ibs066ff2if5">
        <SectionHeading eyebrow="El verdadero problema" title={<span id="problema" data-id="element-115" data-mp="1z05bvdw6lb3u">
              No te falta información.
              <br data-id="element-116" data-mp="1u1lmt4majj79" />
              Te falta <span className="text-brand-red" data-id="element-117" data-mp="1u2disgjsviy2">un sistema que termine en venta.</span>
            </span>} data-id="element-114" data-mp="3nbmpw6ngh1ym" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-118" data-mp="27rp4rje50qqw">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45
        }} className="rounded-2xl border border-white/10 bg-ink-800 p-7" data-id="element-119" data-mp="23rn7dmffqjhf">
            <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-white/45" data-id="element-120" data-mp="1p291iob2ik6s">
              Dónde estás hoy
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-121" data-mp="1k2mmc9boitvc">
              {pains.map(pain => <li key={pain} className="flex gap-3 text-sm leading-relaxed text-white/65" data-id="element-122" data-mp="30guwt5j6dcqm">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" aria-hidden="true" data-id="element-123" data-mp="2vjclj8hoqlfg" />
                  {pain}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45,
          delay: 0.1
        }} className="rounded-2xl border border-brand-cyan/25 bg-ink-800 p-7 ring-1 ring-inset ring-brand-cyan/10" data-id="element-124" data-mp="1y3q902kj97ia">
            <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-brand-cyan" data-id="element-125" data-mp="1agi43lr0o0gs">
              Dónde estarás en 48 horas
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-126" data-mp="1jetxtwn6jedg">
              {shifts.map(shift => <li key={shift} className="flex gap-3 text-sm leading-relaxed text-white/80" data-id="element-127" data-mp="1o5sewyfzsghr">
                  <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-cyan" aria-hidden="true" data-id="element-128" data-mp="qqy0cppsdifm" />
                  {shift}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}